import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.4696 15.9302L11.418 12.8803L12.4783 11.8193L15.53 14.8692C15.8229 15.162 15.8231 15.6369 15.5303 15.9299C15.2375 16.2229 14.7626 16.223 14.4696 15.9302Z",
  fill: "#6F798A"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.79479 5.15251C1.4684 6.54316 1.4684 7.99043 1.79479 9.38109C2.19734 11.0962 3.53748 12.436 5.25449 12.8385C6.64626 13.1648 8.0947 13.1648 9.48647 12.8385C11.2035 12.436 12.5436 11.0962 12.9462 9.38108C13.2726 7.99043 13.2726 6.54316 12.9462 5.15251C12.5436 3.43736 11.2035 2.09762 9.48647 1.6951C8.0947 1.36882 6.64626 1.36882 5.25449 1.6951C3.53748 2.09763 2.19734 3.43735 1.79479 5.15251ZM4.95777 0.429414C2.76037 0.944559 1.04462 2.65932 0.529184 4.85547C0.156939 6.44149 0.156939 8.0921 0.529184 9.67813C1.04462 11.8743 2.76037 13.589 4.95777 14.1042C6.54471 14.4762 8.19625 14.4762 9.78319 14.1042C11.9806 13.589 13.6963 11.8743 14.2118 9.67812C14.584 8.0921 14.584 6.4415 14.2118 4.85547C13.6963 2.65933 11.9806 0.944559 9.78319 0.429414C8.19626 0.0573826 6.54471 0.0573829 4.95777 0.429414Z",
  fill: "#6F798A"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };